/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { css } from "@emotion/react";

import type { HallowElementProps } from "../../../../../../emotion";
import {
  constantSemanticColors,
  cssMediaQueryMinWidthTablet,
  radius,
  spacing,
} from "../../../../../../emotion";
import { CheckmarkIcon } from "../../../icons/Icon/GeneralIcons";

const checkIconStyle: Interpolation = css({
  position: "absolute",
  top: spacing.s,
  right: spacing.s,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: radius.full,
  backgroundColor: constantSemanticColors.onColorHighest,
  backdropFilter: "blur(20px)",
  width: "24px",
  height: "24px",
  [cssMediaQueryMinWidthTablet]: {
    top: spacing.s,
    right: spacing.s,
  },
});

export type ChallengeCheckmarkProps = Omit<HallowElementProps<"div">, "css"> & {
  size?: number;
  css?: Interpolation;
};

export const ChallengeCheckmark = ({
  size = 16,
  css,
  ...props
}: ChallengeCheckmarkProps) => {
  return (
    <div css={[checkIconStyle, css]} {...props}>
      <CheckmarkIcon.SimpleOn
        size={size}
        fill={constantSemanticColors.onColorLowest}
      />
    </div>
  );
};
